const userConstants = {
  AUTHENTICATION_STARTED: "AUTHENTICATION_STARTED",
  AUTHENTICATION_SUCCESSFULL: "AUTHENTICATION_SUCCESSFULL",
  AUTHENTICATION_FAILED: "AUTHENTICATION_FAILED",
  SIGN_OUT: "SIGN_OUT",
  NEW_ACCOUNT_CREATED: "NEW_ACCOUNT_CREATED",
  GET_USER_INFORMATION: "GET_USER_INFORMATION",
  GET_PARTNER_PREFERENCE: "GET_PARTNER_PREFERENCE",
  UPDATE_PARTNER_PREFERENCE: "UPDATE_PARTNER_PREFERENCE",
  GET_USER_PROFILE: "GET_USER_PROFILE",
  UPDATE_USER_PROFILE: "UPDATE_USER_PROFILE",
  GET_PRIVACY_SETTING: "GET_PRIVACY_SETTING",
  UPDATE_PRIVACY_SETTING: "UPDATE_PRIVACY_SETTING",
  UPLOAD_PROFILE_PICTURE: "UPLOAD_PROFILE_PICTURE",
  REMOVE_PROFILE_PICTURE: "REMOVE_PROFILE_PICTURE",
  MALE_IMAGE:
    "https://firebasestorage.googleapis.com/v0/b/fir-amst-8de23.appspot.com/o/placeholder%2Fmale.png?alt=media&token=f37028c3-cb83-4b39-88a7-9eb3d394bd1c",
  FEMALE_IMAGE:
    "https://firebasestorage.googleapis.com/v0/b/fir-amst-8de23.appspot.com/o/placeholder%2Ffemale.png?alt=media&token=9526c2bb-d143-4749-bc41-1bce7fc1f8c1",
  GET_TOP_CONNECTED_MEMBERS: "GET_TOP_CONNECTED_MEMBERS",
  GET_GALLERY_IMAGES: "GET_GALLERY_IMAGES",
  UPDATE_PROFILE_PICTURE: "UPDATE_PROFILE_PICTURE",
  DELETE_GALLERY_IMAGES: "DELETE_GALLERY_IMAGES",
  GET_MOBILE_NUMBER: "GET_MOBILE_NUMBER",
  GET_NEW_JOINED_MEMBERS: "GET_NEW_JOINED_MEMBERS",
  CLEAR_NEW_JOINED_MEMBERS: "CLEAR_NEW_JOINED_MEMBERS",
  GET_TOP_PROFILE_VISITORS: "GET_TOP_PROFILE_VISITORS",
  CLEAR_TOP_PROFILE_VISITORS: "CLEAR_TOP_PROFILE_VISITORS",
  DELETE_USER: "DELETE_USER",
  RE_AUTHENTICATE_USER: "RE_AUTHENTICATE_USER",
  RESET_PASSWORD: "RESET_PASSWORD",
  FORGOT_PASSWORD: "FORGOT_PASSWORD"
};

export default userConstants;



// WEBPACK FOOTER //
// ./src/_constants/userConstants.js